import React from 'react';
import { translate } from '../Services/translation';
import Svg from './Svg';

const MiniCart = ({ quantity, orderTotal, checkoutUrl, showInfo, toggle, icon, label }) => (
    <a href={checkoutUrl} className="cart cart--mini">
        <div className="cart__link--block">
            <Svg icon= { icon }/>
            <span className="cart__quantity">{ quantity }</span>
        </div>
        <div href={checkoutUrl} className="cart__icon-label" >{translate(label)}</div>
    </a>
)

export default MiniCart;